"use strict";
/* eslint-disable @typescript-eslint/naming-convention */
// TODO: 转移client + server + core里面的字段定义/类型判断部分
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_TYPE = exports.PRIMARY_KEY_TYPE = exports.filterFieldKey = void 0;
/**
 * 筛选出符合属性的field key + 补全field key
 */
const filterFieldKey = (field) => ({
    id: field.id || '',
    name: field.name || '',
    desc: field.desc || '',
    type: field.type || 0,
    value: 'value' in field ? field.value : null,
    args: field.args || '',
    width: field.width || undefined,
    maxlength: field.maxlength || undefined,
    required: field.required || false,
    unique: field.unique || false,
    pattern: field.pattern || '',
    readonly: field.readonly || false,
    sort: field.sort || '',
    notAutoSpace: field.notAutoSpace || false,
    triggers: field.triggers || '',
    input: field.input || {},
    dataType: field.dataType,
});
exports.filterFieldKey = filterFieldKey;
var PRIMARY_KEY_TYPE;
(function (PRIMARY_KEY_TYPE) {
    PRIMARY_KEY_TYPE[PRIMARY_KEY_TYPE["INCREASE_ID"] = 100] = "INCREASE_ID";
    PRIMARY_KEY_TYPE[PRIMARY_KEY_TYPE["ID"] = 101] = "ID";
    PRIMARY_KEY_TYPE[PRIMARY_KEY_TYPE["DEFAULT_ID"] = 102] = "DEFAULT_ID";
    PRIMARY_KEY_TYPE[PRIMARY_KEY_TYPE["NUM_INCREASE_ID"] = 103] = "NUM_INCREASE_ID";
    PRIMARY_KEY_TYPE[PRIMARY_KEY_TYPE["RANDOM_ID"] = 104] = "RANDOM_ID";
})(PRIMARY_KEY_TYPE || (exports.PRIMARY_KEY_TYPE = PRIMARY_KEY_TYPE = {}));
var FIELD_TYPE;
(function (FIELD_TYPE) {
    FIELD_TYPE[FIELD_TYPE["TEXT"] = 1] = "TEXT";
    FIELD_TYPE[FIELD_TYPE["TEXTAREA"] = 2] = "TEXTAREA";
    FIELD_TYPE[FIELD_TYPE["URL"] = 3] = "URL";
    FIELD_TYPE[FIELD_TYPE["PIC"] = 4] = "PIC";
    FIELD_TYPE[FIELD_TYPE["SELECT"] = 5] = "SELECT";
    FIELD_TYPE[FIELD_TYPE["SMART_SELECT"] = 6] = "SMART_SELECT";
    FIELD_TYPE[FIELD_TYPE["RELATION"] = 7] = "RELATION";
    FIELD_TYPE[FIELD_TYPE["NUMBER"] = 8] = "NUMBER";
    FIELD_TYPE[FIELD_TYPE["BOOLEAN"] = 9] = "BOOLEAN";
    FIELD_TYPE[FIELD_TYPE["TIME"] = 10] = "TIME";
    FIELD_TYPE[FIELD_TYPE["CTIME"] = 11] = "CTIME";
    FIELD_TYPE[FIELD_TYPE["MTIME"] = 12] = "MTIME";
    FIELD_TYPE[FIELD_TYPE["MULTI_SELECT"] = 13] = "MULTI_SELECT";
    FIELD_TYPE[FIELD_TYPE["CREATOR"] = 14] = "CREATOR";
    FIELD_TYPE[FIELD_TYPE["COLOR"] = 15] = "COLOR";
    FIELD_TYPE[FIELD_TYPE["DEPRECATED_RICHTEXT"] = 16] = "DEPRECATED_RICHTEXT";
    FIELD_TYPE[FIELD_TYPE["RICHTEXT"] = 17] = "RICHTEXT";
    FIELD_TYPE[FIELD_TYPE["SORT"] = 18] = "SORT";
    FIELD_TYPE[FIELD_TYPE["LARGE_RICHTEXT"] = 19] = "LARGE_RICHTEXT";
    FIELD_TYPE[FIELD_TYPE["JSONTEXT"] = 20] = "JSONTEXT";
    FIELD_TYPE[FIELD_TYPE["DECIMALS"] = 21] = "DECIMALS";
    FIELD_TYPE[FIELD_TYPE["FILE"] = 22] = "FILE";
    FIELD_TYPE[FIELD_TYPE["OWNER"] = 23] = "OWNER";
    FIELD_TYPE[FIELD_TYPE["MODIFIER"] = 24] = "MODIFIER";
    FIELD_TYPE[FIELD_TYPE["CODE_BLOCK"] = 25] = "CODE_BLOCK";
    FIELD_TYPE[FIELD_TYPE["JSON"] = 26] = "JSON";
    FIELD_TYPE[FIELD_TYPE["RTX"] = 27] = "RTX";
    FIELD_TYPE[FIELD_TYPE["PASSWORD"] = 28] = "PASSWORD";
    FIELD_TYPE[FIELD_TYPE["EXEDITOR_RICHTEXT"] = 29] = "EXEDITOR_RICHTEXT";
    FIELD_TYPE[FIELD_TYPE["CASCADER"] = 30] = "CASCADER";
    FIELD_TYPE[FIELD_TYPE["MARKDOWN"] = 31] = "MARKDOWN";
})(FIELD_TYPE || (exports.FIELD_TYPE = FIELD_TYPE = {}));
